import { Pagination, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table/interface';
import * as React from 'react';
import { IMemberStatementUsageDetails } from '../../../types/IMemberStatementSearchResult';
import IMembersPortalComponentDataItem from '../../../../redux/types/IMembersPortalComponentDataItem';
import ErrorFallback from '../../../../telemetry/components/ErrorFallback';
import { MembersPortalService } from '../../../../redux/services/MembersPortalService';
import { IMemberStatementUsageDetailsState } from '../../../../redux/types/IMemberStatementState';
import { useServerPagination } from '../../hooks/useServerPagination';
import { PAGE_SIZE_OPTIONS } from '../../../Consts';
import { formatCurrencyWithCommas } from '../../../../util/tools';

export interface IMemberStatementUsageDetailsGridProps {
    usageDetails: IMemberStatementUsageDetailsState;
    usageDetailsGridsComponentData: IMembersPortalComponentDataItem;
    userNameNumber: string;
}

const DEFAULT_PAGE_SIZE = 500;

export const MemberStatementUsageDetailsGrid: React.FC<IMemberStatementUsageDetailsGridProps> = (props) => {
    const fetchPage = (token?: string) => {
        if (!props.usageDetails.statementLineID) {
            return Promise.reject(new Error('Refresh the statement and reopen Usage Details.'));
        }

        return MembersPortalService.getStatementUsageDetails(
            props.usageDetails.paymentRunID,
            props.userNameNumber,
            props.usageDetails.distributionCode,
            props.usageDetails.poolCode,
            props.usageDetails.segment,
            props.usageDetails.statementLineID,
            token
        );
    };

    const pagination = useServerPagination<IMemberStatementUsageDetails>({
        queryKey: [
            'member-usage-details',
            props.usageDetails?.refreshKey
        ],
        fetchPage,
        pageSize: DEFAULT_PAGE_SIZE
    });

    const data: IMemberStatementUsageDetails[] = pagination.data.map(u => ({
        ...u,
        amount: formatCurrencyWithCommas(u.amount, false, 2)
    }));

    const columns: ColumnsType<IMemberStatementUsageDetails> =
        props.usageDetailsGridsComponentData.fields.map(f => ({
            title: f.data,
            dataIndex: f.name,
            key: f.name,
            sorter: ['usageTitles', 'usagePerformers'].includes(f.name)
                ? (a, b) => a[f.name]?.localeCompare(b[f.name])
                : undefined
        }));

    if (!props.usageDetails) {
        return null;
    }

    if (pagination.isError) {
        return <ErrorFallback />;
    }

    return (
        <div>
            <div style={{ width: '100%', overflow: 'auto' }}>
                <Table
                    dataSource={data}
                    columns={columns}
                    pagination={false}
                    loading={pagination.isLoading}
                />
            </div>
            <div style={{ marginTop: 16, display: 'flex', justifyContent: 'flex-end' }}>
                <Pagination
                    current={pagination.currentPage}
                    pageSize={pagination.pageSize}
                    total={pagination.total}
                    showSizeChanger
                    pageSizeOptions={PAGE_SIZE_OPTIONS}
                    onChange={pagination.onPageChange}
                />
            </div>
        </div>
    );
};
